import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IVersion } from '../models/version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(
    private http: HttpClient,
  ){}


  getVersion(){
    return this.http.get<IVersion>(
      `${environment.baseUrl}/Version/getVersion`
    )
  }
}
